(function() {
  const synchronizeLayout = () => {
    const sections = document.querySelectorAll('.icon-with-text-custom[data-equalize-title-height="true"]');
    
    sections.forEach(section => {
      const icons = section.querySelectorAll('.icon-with-text-custom__icon');
      if (icons.length === 0) return;

      // Reset heights to get accurate natural reading
      icons.forEach(icon => {
        icon.style.height = 'auto'; // Use height instead of minHeight for strict enforcement
        icon.style.display = 'block';
        icon.style.alignItems = 'normal';
        icon.style.justifyContent = 'normal';
      });

      // Calculate max natural height
      let maxHeight = 0;
      icons.forEach(icon => {
        const height = icon.offsetHeight;
        if (height > maxHeight) maxHeight = height;
      });

      // Apply the absolute layout lock
      if (maxHeight > 0) {
        icons.forEach(icon => {
          icon.style.height = maxHeight + 'px';
          icon.style.display = 'flex';
          icon.style.alignItems = 'flex-end'; // Anchor images to the bottom line
          icon.style.justifyContent = 'center';
        });
      }
    });
  };

  const init = () => {
    synchronizeLayout();
    
    // We use intervals for robust lazy-load capturing without causing layout thrashing 
    // or relying on flaky ResizeObserver events with Splide clones.
    [100, 300, 700, 1500, 3000].forEach(delay => {
      setTimeout(synchronizeLayout, delay);
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', synchronizeLayout);

  document.addEventListener("shopify:section:load", (e) => {
    if (e.target.querySelector('.icon-with-text-custom[data-equalize-title-height="true"]')) {
      init();
    }
  });

  // Handle splide ready custom events natively
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.icon-with-text-custom[data-equalize-title-height="true"]').forEach(sectionEl => {
      const match = sectionEl.className.match(/section-([a-zA-Z0-9_\-]+)-padding/);
      if (match && match[1]) {
        document.addEventListener(`eurus:${match[1]}:splide-ready`, init);
      }
    });
  });

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    init();
  }
})();
